<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="学员分类">
          <el-select v-model="formInline.employee_identity" placeholder="请选择学员分类" clearable style="width: 150px;">
            <el-option label="正式员工" value="1"></el-option>
            <el-option label="临时员工" value="2"></el-option>
            <el-option label="外包员工" value="3"></el-option>
            <el-option label="实习员工" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属组织">
          <el-select v-model="formInline.organization" placeholder="请选择所属组织" clearable filterable style="width: 200px;">
            <el-option v-for="item in organizationList" :key="item.ma_company_id" :label="item.name" :value="item.ma_company_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="综合查询">
          <el-input placeholder="请输入姓名/身份证号/手机号" v-model="formInline.search" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="账户状态">
          <el-select v-model="formInline.account_status" placeholder="请选择账户状态" clearable style="width: 150px;">
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" placeholder="请选择状态" clearable style="width: 150px;">
            <el-option label="在职" value="1"></el-option>
            <el-option label="离职" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="岗位">
          <el-input placeholder="请输入岗位" v-model="formInline.position" style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="牌照号码">
          <el-input placeholder="请输入牌照号码" v-model="formInline.license_number" style="width: 150px;"></el-input>
        </el-form-item>
        <el-form-item label="注册时间">
          <el-date-picker
            v-model="formInline.create_time_range"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 240px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加员工</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column label="注册照" width="80">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.image"
                  style="width: 50px; height: 50px;"
                  :src="scope.row.image"
                  :preview-src-list="[scope.row.image]"
                  fit="cover">
                </el-image>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="100"></el-table-column>
            <el-table-column prop="id_card" label="身份证号" width="180"></el-table-column>
            <el-table-column prop="mobile" label="手机号" width="120"></el-table-column>
            <el-table-column prop="organization_name" label="所属组织" width="150"></el-table-column>
            <el-table-column prop="license_number" label="车牌号" width="120"></el-table-column>
            <el-table-column prop="plan_count" label="计划进行中" width="100">
              <template slot-scope="scope">
                <el-tag type="primary">{{ scope.row.plan_count || 0 }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="280">
              <template slot-scope="scope">
                <el-button @click="detailClick(scope.row)" type="text" size="small">详情</el-button>
                <el-button @click="resignClick(scope.row)" type="text" size="small">{{ hasResignAudit(scope.row) ? '审核离职' : '离职' }}</el-button>
                <el-button @click="unbindLicenseClick(scope.row)" type="text" size="small">{{ scope.row.is_unbindLicense === 1 ? '解绑车牌' : '绑定车牌' }}</el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="resetPasswordClick(scope.row)" type="text" size="small">重置密码</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :ma_yg_id="ma_yg_id"  v-if="open_edit"   @close="closeEdit"></Edit>
    <Detail :open_detail="open_detail" :ma_yg_id="ma_yg_id" v-if="open_detail" @close="closeDetail"></Detail>

    <el-dialog title="重置密码" :visible.sync="resetPasswordDialogVisible" @close='resetPasswordDialogVisible = false' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true" width="400px">
      <el-form :model="resetPasswordForm" :rules="resetPasswordRules" ref="resetPasswordForm" label-width="100px">
        <el-form-item label="新密码" prop="password">
          <el-input v-model="resetPasswordForm.password" type="password" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="resetPasswordForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetPasswordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitResetPassword">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>

    <ResignAudit :open_add="open_resign_audit" :employee="employee" :ma_yg_id="resignAuditForm.ma_yg_id" :employeeName="resignAuditForm.employeeName" :idCard="resignAuditForm.idCard"  v-if="open_resign_audit" @close="closeResignAudit"></ResignAudit>
    <ResignPosition :open_add="open_resign_position" :ma_yg_id="resignPositionForm.ma_yg_id" :employeeName="resignPositionForm.employeeName" :employeeList="resignPositionForm.employeeList" v-if="open_resign_position" @close="closeResignPosition"></ResignPosition>
    <BindVehicle :visible.sync="open_bind_vehicle" :employee-id="ma_yg_id" v-if="open_bind_vehicle" @close="closeBindVehicle" @success="bindVehicleSuccess"></BindVehicle>
  
  </div>
</template>

<script>
  import AfuncApi from '@/api/afunc.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import Detail from './part/detail.vue';
  import ResignAudit from './part/ResignAudit.vue';
  import ResignPosition from './part/ResignPosition.vue';
  import BindVehicle from './part/BindVehicle.vue';

  export default {
    components: {
      Add,
      Edit,
      Detail,
      ResignAudit,
      ResignPosition,
      BindVehicle,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          organization:"",
          account_status:"",
          status:"",
          employee_identity:"",
          position:"",
          license_number:"",
          create_time_range:[]
        },
        /*组织列表*/
        organizationList: [],

        open_add:false,
        open_edit:false,
        open_detail:false,
        open_resign_audit:false,
        open_resign_position:false,
        open_bind_vehicle:false,
        ma_yg_id:"",
        dialogVisible:false,
        resetPasswordDialogVisible:false,
        employee: [],
        resignAuditForm: {
          ma_yg_id: '',
          employeeName: '',
          idCard: '',
          departmentName: '',
          positionName: ''
        },
        resignPositionForm: {
          ma_yg_id: '',
          employeeName: '',
          employeeList: []
        },
        resetPasswordForm: {
          password: '',
          confirmPassword: ''
        },
        resetPasswordRules: {
          password: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
          ],
          confirmPassword: [
            { required: true, message: '请再次输入新密码', trigger: 'blur' },
            { validator: this.validateConfirmPassword, trigger: 'blur' }
          ]
        },
        currentResetUserId: null,
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
      /*获取组织列表*/
      this.getOrganizationList();
    },
    methods: {
      validateConfirmPassword(rule, value, callback) {
        if (value !== this.resetPasswordForm.password) {
          callback(new Error('两次输入的密码不一致'));
        } else {
          callback();
        }
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//员工标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    closeDetail(e){
      this.open_detail=false;
    },
    getData(){
      this.getTableList();
    },
    hasResignAudit(row) {
      if (row.employee && Array.isArray(row.employee)) {
        return row.employee.some(item => item.resign_aduit == 1);
      }
      return false;
    },
      /*获取组织列表*/
      getOrganizationList() {
        let self = this;
        AfuncApi.call({
          model: 'ma_company',
          action: 'getList',
          page: 1,
          list_rows: 1000
        }).then(data => {
          self.organizationList = data.data.list.data;
        }).catch(error => {});
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        
        if (Params.create_time_range && Params.create_time_range.length === 2) {
          Params.start_time = Params.create_time_range[0];
          Params.end_time = Params.create_time_range[1];
        }
        delete Params.create_time_range;
        
        self.loading = true;
        AfuncApi.call({
          model: 'ma_yg',
          action: 'getList',
          ...Params
        })
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.ma_yg_id = row.ma_yg_id;
        this.open_edit = true
      },

      /*查看详情*/
      detailClick(row) {
        this.ma_yg_id = row.ma_yg_id;
        this.open_detail = true;
      },

      /*离职*/
      resignClick(row) {
        let self = this;
        if (self.hasResignAudit(row)) {
          self.resignAuditForm.ma_yg_id = row.ma_yg_id;
          self.resignAuditForm.employeeName = row.name;
          self.resignAuditForm.idCard = row.id_card;
          self.employee = row.employee || [];
          self.open_resign_audit = true;
        } else {
          self.resignPositionForm.ma_yg_id = row.ma_yg_id;
          self.resignPositionForm.employeeName = row.name;
          self.resignPositionForm.employeeList = row.employee || [];
          self.open_resign_position = true;
        }
      },

      /*解绑/绑定车牌*/
      unbindLicenseClick(row) {
        if (row.is_unbindLicense === 1) {
          this.unbindLicense(row);
        } else {
          this.openBindVehicle(row);
        }
      },

      /*解绑车牌*/
      unbindLicense(row) {
        let self = this;
        self.$confirm('您确定要解绑该员工的车牌吗?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          AfuncApi.call({
            model: 'ma_yg',
            action: 'unbindLicense',
            ma_yg_id: row.ma_yg_id
          })
          .then(data => {
            if (data.code == 1) {
              self.$message({
                message: '解绑车牌成功',
                type: 'success'
              });
              this.getTableList();
            } else {
              self.$message.error(data.msg || '解绑车牌失败');
            }
          })
          .catch(error => {
            self.$message.error('解绑车牌失败');
          });
        })
        .catch(() => {});
      },

      /*打开绑定车牌弹窗*/
      openBindVehicle(row) {
        this.ma_yg_id = row.ma_yg_id;
        this.open_bind_vehicle = true;
      },

      /*关闭绑定车牌弹窗*/
      closeBindVehicle() {
        this.open_bind_vehicle = false;
        this.ma_yg_id = '';
      },

      /*绑定成功回调*/
      bindVehicleSuccess() {
        this.open_bind_vehicle = false;
        this.ma_yg_id = '';
        this.getTableList();
      },

      closeResignAudit() {
        this.open_resign_audit = false;
        this.employee = [];
        this.resignAuditForm = {
          ma_yg_id: '',
          employeeName: '',
          idCard: '',
          departmentName: '',
          positionName: ''
        };
        this.getTableList();
      },

      closeResignPosition() {
        this.open_resign_position = false;
        this.resignPositionForm = {
          ma_yg_id: '',
          employeeName: '',
          employeeList: []
        };
        this.getTableList();
      },

      /*重置密码*/
      resetPasswordClick(row) {
        this.currentResetUserId = row.ma_yg_id;
        this.resetPasswordForm.password = '';
        this.resetPasswordForm.confirmPassword = '';
        this.resetPasswordDialogVisible = true;
        if (this.$refs.resetPasswordForm) {
          this.$refs.resetPasswordForm.clearValidate();
        }
      },

      /*提交重置密码*/
      submitResetPassword() {
        let self = this;
        this.$refs.resetPasswordForm.validate((valid) => {
          if (valid) {
            AfuncApi.call({
              model: 'ma_yg',
              action: 'resetPassword',
              ma_yg_id: self.currentResetUserId,
              password: self.resetPasswordForm.password
            })
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '重置密码成功',
                  type: 'success'
                });
                self.resetPasswordDialogVisible = false;
              } else {
                self.$message.error(data.msg || '重置密码失败');
              }
            })
            .catch(error => {
              self.$message.error('重置密码失败');
            });
          } else {
            return false;
          }
        });
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            AfuncApi.call({
              model: 'ma_yg',
              action: 'del',
              ma_yg_id: row.ma_yg_id
            })
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/ma_yg/index/index.vue